import React, { useEffect, useState } from 'react';
const headlines = ['Wie sieht eine zielgerichtete Entwicklung für Potenzialträger aus?', 'Passt eine Führungskraft zu unserer Kultur?'];
export const AssessmentCenterPage: React.FC = () => {
  const [currentHeadline, setCurrentHeadline] = useState(0);
  const [fadeState, setFadeState] = useState<'visible' | 'fading'>('visible');
  useEffect(() => {
    const interval = setInterval(() => {
      setFadeState('fading');
      setTimeout(() => {
        setCurrentHeadline(prev => (prev + 1) % headlines.length);
        setFadeState('visible');
      }, 500);
    }, 4000);
    return () => clearInterval(interval);
  }, []);
  return <>
      <section className="w-full bg-white pt-16 pb-0 px-6 md:px-12 lg:px-20" data-id="element-177">
        <div className="max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-12 items-center" data-id="element-178">
          <div data-id="element-179">
            <h1 className="text-3xl md:text-4xl text-orange-500 font-light mb-6 transition-opacity duration-500" style={{
            opacity: fadeState === 'visible' ? 1 : 0,
            minHeight: '120px'
          }} data-id="element-180">
              {headlines[currentHeadline]}
            </h1>
          </div>
          <div className="flex justify-center" data-id="element-181">
            <img src="https://cdn.magicpatterns.com/uploads/kgyA7BLNSMYSwBTC36JF6B/Eva-Schifferer-Management_Diagnostik-Assessment_Center.png" alt="Assessment Center Join Our Team" className="max-h-96 object-contain" data-id="element-182" />
          </div>
        </div>
      </section>

      <section className="w-full text-white py-16 px-6 md:px-12 lg:px-20" style={{
      backgroundColor: '#545454'
    }} data-id="element-183">
        <div className="max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-12" data-id="element-184">
          <div data-id="element-185">
            <p className="mb-6 text-base leading-relaxed" data-id="element-186">
              Das AC eignet sich in Fragen der externen Besetzung hochrangiger
              Schlüsselpositionen als auch in der Personalentwicklung als
              Development Center. Einzelne Teilnehmer oder mehrere Personen
              durchlaufen möglichst praxisnahe Aufgaben und werden von mehreren
              Beobachtern beurteilt.
            </p>
            <p className="mb-6 text-base leading-relaxed" data-id="element-187">
              Ich bin seit über 15 Jahren spezialisiert auf die Konzeption,
              Durchführung und Nachbereitung von Assessment Centern sowie die
              Beratung zu Prozessen rund um die diagnostischen Verfahren.
            </p>
          </div>
          <div data-id="element-188">
            <p className="mb-6 text-base leading-relaxed" data-id="element-189">
              Die professionelle Durchführung und die Prozess-Sicherheit
              generiert eine hohe Akzeptanz auf Teilnehmer- und Beobachterseite.
            </p>
            <p className="mb-6 text-base leading-relaxed font-semibold" data-id="element-190">
              Elemente des Assessment Centers sind:
            </p>
            <ul className="mb-6 space-y-3 text-base leading-relaxed" data-id="element-191">
              <li className="flex items-start" data-id="element-192">
                <span className="mr-3 mt-1.5 w-1.5 h-1.5 bg-white rounded-full flex-shrink-0" data-id="element-193"></span>
                <span data-id="element-194">Biographische und kompetenzbasierte Interviews</span>
              </li>
              <li className="flex items-start" data-id="element-195">
                <span className="mr-3 mt-1.5 w-1.5 h-1.5 bg-white rounded-full flex-shrink-0" data-id="element-196"></span>
                <span data-id="element-197">
                  Maßgeschneiderte, vielfältige Übungen und Rollenspiele
                </span>
              </li>
              <li className="flex items-start" data-id="element-198">
                <span className="mr-3 mt-1.5 w-1.5 h-1.5 bg-white rounded-full flex-shrink-0" data-id="element-199"></span>
                <span data-id="element-200">Fallstudien und Präsentationen</span>
              </li>
            </ul>
            <p className="mb-6 text-base leading-relaxed" data-id="element-201">
              Lassen Sie uns darüber sprechen und nehmen Sie Kontakt auf!
            </p>
            <a href="/kontakt" className="inline-block bg-orange-500 hover:bg-orange-600 text-white px-8 py-3 transition-colors" data-id="element-202">
              Lassen Sie uns sprechen
            </a>
          </div>
        </div>
      </section>
    </>;
};